export type Tool = 'select' | 'add' | 'rotate' | 'fly' | 'rct';

export function flashHint(text: string, ms = 2600): void {
  const el = document.getElementById('mode-hint');
  if (!el) return;
  el.textContent = text;
  el.style.opacity = '1';
  window.clearTimeout((el as any)._t);
  (el as any)._t = window.setTimeout(() => {
    el.textContent = defaultHint;
  }, ms);
}

export let defaultHint = '';
export function setDefaultHint(text: string): void {
  defaultHint = text;
  const el = document.getElementById('mode-hint');
  if (el) el.textContent = text;
}
